import { render } from "./configure-vehicle.vue?vue&type=template&id=0af65c82&scoped=true"
import script from "./configure-vehicle.vue?vue&type=script&lang=js"
export * from "./configure-vehicle.vue?vue&type=script&lang=js"

import "./configure-vehicle.vue?vue&type=style&index=0&id=0af65c82&scoped=true&lang=scss"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af65c82"]])

export default __exports__